module.exports = __webpack_public_path__ + "img/703e6dfb168301a8b8007f32706e7966.png";